import { memo, useId, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { ActionList } from '@xemplo/action-list';
import {
  AssignPayrollManagerModal,
  ModalDialogRef,
} from '@xemplo/assign-payroll-manager';
import { PayrunListItem } from '@xemplo/gp-types';
import { IconButton } from '@xemplo/icon-button';
import { createListItems } from '@xemplo/stateful-list-core';

import { getPayrunDetailPath } from '../payrun-base-table.helper';

import * as S from './more-actions.styles';

export const MoreActions = memo((props: { payrunListItem: PayrunListItem }) => {
  const { payrunListItem } = props;
  const viewId = useId();
  const assignPayrollManagerId = useId();
  const navigate = useNavigate();
  const modalRef = useRef<ModalDialogRef>(null);

  function handleView() {
    navigate(getPayrunDetailPath(payrunListItem));
  }

  function handleAssignPayrollManager() {
    modalRef.current?.openModalDialog();
  }

  const items = createListItems()
    .addGroup((group) => {
      group.addItem(viewId, 'View', handleView);
      group.addItem(
        assignPayrollManagerId,
        'Assign Payroll Manager',
        handleAssignPayrollManager,
      );
      return group;
    })
    .build();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <ActionList listProps={{ items }} isMulti={false} closeOnSelect>
        <IconButton naked id="more-actions-button" ariaLabel="action button">
          <S.NoPointerIcon />
        </IconButton>
      </ActionList>
      <AssignPayrollManagerModal ref={modalRef} payrun={payrunListItem} />
    </div>
  );
});
